import app from '@frontend/application-container';
import { img } from '@phi/components';
import { SettingsEntry } from '../settings-entry';
import FormToggle from '@frontend/components/FormToggle';
import { h } from 'vue';
import icon from '../../../../../frontend/phi3d/src/assets/img/SVG_icons/Top/search/inside_red.svg';

export function InsideRed() {
    return SettingsEntry(
        'Inside side red',

        'Make the inside part of all bodies red color to distinguish from the outside.',

        img(icon),

        h(FormToggle, {
            value: app.settings.inside_red,
            'onUpdate:value': x => app.settings.inside_red = x,
        }),
    );
}
